import { render, staticRenderFns } from "./Report106.vue?vue&type=template&id=1f486145"
import script from "./Report106.vue?vue&type=script&lang=js"
export * from "./Report106.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports